import React, { useState, useEffect } from 'react';
import List from '../../components/Crud/List';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import {
  upsertFilterToKey,
  getLastFilterByKey,
} from '../../services/filterService';
import EstimatesFilter, {
  EstimateFilterFields,
} from '../estimates/EstimatesFilter';
import { EstimateModel } from '../estimates/EstimatesIndex';
import EstimatesList from '../estimates/EstimatesList';

interface CustomersEstimatesProps {
  customerId: number;
}

export default function CustomersEstimates({
  customerId,
}: CustomersEstimatesProps) {
  const pageKey = 'customers-estimates';

  const [isLoading, setIsLoading] = useState(false);
  const [estimates, setEstimates] = useState([] as EstimateModel[]);
  const [filterFields, setFilterFields] = useState<EstimateFilterFields>(
    null as unknown as EstimateFilterFields
  );

  const {
    user: { organization },
  } = useAuth();

  async function getEstimates(data: EstimateFilterFields) {
    if (organization) {
      setIsLoading(true);
      const { customer, statuses, ...rest } = data;
      const response = await api.get(
        `organizations/${organization.id}/estimates`,
        {
          params: {
            customer: customerId,
            statuses: statuses || [],
            ...rest,
          },
        }
      );
      setEstimates(response.data.data);
      setIsLoading(false);
    }
  }

  const onFilterSubmit = (data: EstimateFilterFields) => {
    const filter = new EstimateFilterFields(data);
    upsertFilterToKey(pageKey, filter);
    setFilterFields(filter);
    getEstimates(data);
  };

  useEffect(() => {
    const filters = getLastFilterByKey(pageKey, EstimateFilterFields);
    onFilterSubmit(filters);
  }, [organization]);

  return (
    <div className='mt-2'>
      <List
        isLoading={isLoading}
        title=''
        newItemUrl={`/estimates/new?customerId=${customerId}`}
        withNewActionTargetBlank
        withTitle={false}
        filter={
          <EstimatesFilter
            filterFields={filterFields}
            onSubmit={onFilterSubmit}
            pageKey={pageKey}
            withCustomerFilter={false}
          />
        }
      >
        <EstimatesList estimates={estimates} />
      </List>
    </div>
  );
}
